import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconLabel = ({ icon, label }) => (
  <p>
    <FontAwesomeIcon className="icon-color" icon={icon} />
    <span className="ml-1">{label}</span>
  </p>
);

IconLabel.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default IconLabel;
